var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAffiliatesProgram = function SvgAffiliatesProgram(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.333 22.666a7.333 7.333 0 1 0 0-14.666 7.333 7.333 0 0 0 0 14.666Zm0 1.334a8.667 8.667 0 1 1 0-17.334 8.667 8.667 0 0 1 0 17.334ZM4 6.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334ZM26.667 29.333a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333ZM26 8a3.334 3.334 0 1 1 0-6.667A3.334 3.334 0 0 1 26 8Zm0-1.333a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM4.667 28a3.333 3.333 0 1 1 0-6.667 3.333 3.333 0 0 1 0 6.667Zm0-1.333a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#7C5EE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M5.333 5.333h1.334v1.334H5.334V5.334Zm1.334 1.334H8V8H6.667V6.667ZM8 8h1.334v1.334H8V8ZM6.667 21.334H8v1.333H6.667v-1.334ZM8 20h1.334v1.334H8V20ZM21.334 8h1.333v1.334h-1.334V8Zm1.333-1.333H24V8h-1.333V6.667Zm-1.334 14.666h1.334v1.334h-1.334v-1.334Zm1.334 1.334H24V24h-1.333v-1.333ZM24 24h1.334v1.334H24V24Z",
    fill: "#7C5EE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.161 10.5a.914.914 0 0 0-.901-.494.918.918 0 0 0-.81.512l-3.68 7.426a.978.978 0 0 0 .042.952c.179.286.49.454.82.436a.92.92 0 0 0 .776-.513l.925-1.48h4.016l.908 1.48a.92.92 0 0 0 .776.513.913.913 0 0 0 .82-.436.978.978 0 0 0 .043-.95l-3.736-7.447h.001Zm-2.117 5.492 1.29-3.126 1.28 3.126h-2.57Z",
    fill: "#7C5EE2"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAffiliatesProgram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "8c12cbf548c81f8817200af7cfe9cfef.svg";